import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterContentInit, AfterViewChecked, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StrategyService } from '../services/strategy.service';
import { SocketService } from '../services/socket.service';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { Strategy } from '../interfaces/models/strategy.model';
import { switchMap } from 'rxjs';
import { SubstringPipe } from '../pipes/substring.pipe';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DirectionService } from '../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { sidebarTogglerService } from '../services/sidebar-toggler.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Strategy404Component } from '../shared/components/strategy404/strategy404.component';
import { TooltipModule } from 'primeng/tooltip';

const weightColors = {
  25: "#cc3300",
  20: "#ff9966",
  15: "#ffcc00",
  10: "#99cc33",
  5: "#339900",
  1: "#28a745"
}


import { NavTitlePipe } from '../pipes/nav-title.pipe';

@Component({
  selector: 'app-ststrategy-alignment',
  standalone: true,
  imports: [
    NavTitlePipe,TooltipModule, ButtonModule, TranslateModule, TagModule, DropdownModule, Strategy404Component, TranslateModule, TableModule, CommonModule, SubstringPipe, FormsModule],
  templateUrl: './strategy-alignment.component.html',
  styleUrl: './strategy-alignment.component.scss',
  animations: [
    trigger('toggleAnimation', [
      state('void', style({
        opacity: 0,
        transform: 'translateY(-20px)'
      })),
      state('*', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition(':enter', [
        animate('300ms ease-out')
      ]),
      transition(':leave', [
        animate('300ms ease-in')
      ])
    ]),
    trigger('fadeInOut', [
      transition(':enter', [ // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate('0.8s ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [ // :leave is alias to '* => void'
        animate('0.8s ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class StrategyAlignmentComponent implements OnInit, OnDestroy, AfterViewChecked {
  selectedStrategyId = 0;
  strategyOptions = [] as { name: string, strategyId: number }[];
  goalListId = 0;
  indicatorListId = 0;
  selectedPillarId = 0;
  alignmentStrategy = {} as any;
  project = {} as any;
  dir!: 'rtl' | 'ltr';
  tabletype = 'goalsAndIndicators'
  selectedProject = {} as any;

  constructor(
    private strategyService: StrategyService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private sidebarTogglerService: sidebarTogglerService,
    private router: Router,
    private route: ActivatedRoute,
    private elRef: ElementRef
  ) {


  }
  ngAfterViewChecked(): void {
    document.getElementById(`goals-${this.selectedPillarId}`)?.scrollIntoView();
  }

  ngOnDestroy(): void {
    this.sidebarTogglerService.setSidaBarState(true);
  }

  ngOnInit(): void {
    this.sidebarTogglerService.setSidaBarState(false);
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.selectedStrategyId = +(this.route.snapshot.paramMap.get('strategyId') ?? '0');
    if (this.selectedStrategyId) {
      this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((response: any) => {
        this.alignmentStrategy = response['data']['strategy'];
        this.selectedStrategyId = this.alignmentStrategy.id;
      })

    } else {
      this.strategyService.defaultStrategy$.pipe(switchMap((x) => {
        return this.strategyService.getStrategyAlignment(x?.id.toString() || '0')
      })).subscribe((response: any) => {
        this.alignmentStrategy = response['data']['strategy'];
        this.selectedStrategyId = this.alignmentStrategy.id;
      })
    }



    // this.strategyService.getStrategyAlignment(this.selectedStrategyId.toString()).subscribe((response: any) => {
    //   this.alignmentStrategy = response['data']['strategy']
    //   console.log('this.alignmentStrategy', this.alignmentStrategy);
    // })
    //strategy options dropdownList
    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })
  }

  animationState: string = 'up';

  toggleAnimation() {
    this.animationState = this.animationState === 'up' ? 'down' : 'up';
  }
  isModalVisible = false;

  goalListExpanded = false

  strategyOptionsChange() {
    this.strategyService.getStrategyAlignment(this.selectedStrategyId.toString()).subscribe((response: any) => {
      this.alignmentStrategy = response['data']['strategy']

      console.log('this.alignmentStrategy', this.alignmentStrategy);
    })
    this.socketService.setRefreshNotification(this.selectedStrategyId)

  }
  closeModal() {
    this.tabletype = 'goalsAndIndicators'
    this.isModalVisible = false;
  }

  tableType(tableType: string) {
    this.tabletype = tableType;
  }
  showModal(project: any) {
    this.selectedProject = project;
    this.strategyService.GetProjectPerformance(this.selectedStrategyId, project.id).subscribe((response: any) => {
      this.project = response['data'];
      console.log('this.project', this.project);
    })

    // this.strategyService.
    this.isModalVisible = true;
  }

  toggoleGoals(goalId: number, no_projects: number) {

    if (!no_projects) {
      return;
    }
    if (goalId == this.goalListId) {
      this.goalListId = 0;
      return;
    }
    this.goalListId = goalId
    this.goalListExpanded = !this.goalListExpanded;
  }

  toggleIndicators(goalId: number, no_indicators: number) {
    if (!no_indicators) {
      return;
    }
    if (goalId == this.indicatorListId) {
      this.indicatorListId = 0;
      return;
    }
    this.indicatorListId = goalId;
  }

  selectPillar(pillarId: number, goalsLength: number) {
    if (!goalsLength) {
      return;
    }
    this.goalListId = 0;
    this.indicatorListId = 0;
    this.selectedPillarId = pillarId;
  }

  getProgressPercentageStyle(progressPercentage: number) {
    if (progressPercentage >= 90) {
      return { 'background-color': '#28A745' };
    } else if (progressPercentage >= 70) {
      return { 'background-color': '#4258A4' };
    } else {
      return { 'background-color': '#F9BE52' };
    }
  }



  getWeightColor(weight: number) {
    if (weight == 1) return weightColors[1]
    if (weight > 1 && weight <= 5) return weightColors[5]
    if (weight > 5 && weight <= 10) return weightColors[10]
    if (weight > 10 && weight <= 15) return weightColors[15]
    if (weight > 15 && weight <= 20) return weightColors[20]
    if (weight > 20 && weight <= 25) return weightColors[25]
    return ''
  }
  goBack() {
    history.back();
  }
}
